<template>
  <div>
    <!-- 头部 -->
    <div class="top">
      <NavTop activeIndex="0" v-if="isTop"></NavTop>
      <NavTop1 activeIndex="0" v-else></NavTop1>
    </div>
    <!-- 直播区 -->
    <div class="block"
      :style="{ backgroundImage: 'url(' + bgImg + ')', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }">
      <div class="" style="width: 1200px; height: 70px; margin: 0 auto 0"></div>
      <div class="" style="
          width: 1200px;
          height: 567px;
          margin: 0 auto 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #000;
        ">
        <div class="videoBox" style="
            width: 1015px;
            height: 567px;
            position: relative;
            background-color: #000;
          ">
          <div class="" style="width: 1005px">
            <div id="" style="position: relative">
              <liveTv :islive="1" path="main" :reserve="reserve" :info="detail" :aotoPl="aotoPl"></liveTv>
            </div>
          </div>
        </div>
        <div class="" style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 567px;
          ">
          <div class="" style="
              width: 167px;
              height: 102px;
              border-radius: 4px;
              margin-right: 10px;
              border-radius: 10px;
              position: relative;
            " v-for="(item, index) in topList" :key="index">
            <img :src="baseUrl + item.cover_image" alt="" style="width: 167px; height: 102px; border-radius: 10px"
              :class="current2 == index ? 'active2' : ''" @click="changTop(index)" />
            <img :src="item.home_img" alt="" style="
                height: 40px;
                width: 40px;
                position: absolute;
                top: 30px;
                left: 10px;
              " v-if="item.types == 3" />
            <img :src="item.away_img" alt="" style="
                height: 40px;
                width: 40px;
                position: absolute;
                top: 30px;
                right: 10px;
              " v-if="item.types == 3" />
          </div>
        </div>
      </div>
    </div>

    <div class="main-box" v-loading="loading">
      <!-- 滑动区 -->
      <div class="" style="position: relative; height: 130px">
        <div class="" style="position: absolute; left: -60px; top: 50px" @click="leftSlide1">
          <i class="el-icon-arrow-left" style="margin: 0 10px; font-size: 40px"></i>
        </div>
        <!-- <div style="
            background-color: #fff;
            border: 1px solid #eee;
            border-right: none;
            border-radius: 4px;
            overflow-x: scroll;
            display: flex;
            height: 130px;
          " class="scroll_wrapper1" ref="wrapperCon1">
          <div class="" v-for="(item, index) in couseList" :key="index" style="
              border-right: 1px solid #eee;
              padding: 16px;
              box-sizing: border-box;
              flex-shrink: 0;
              width: 240px;
              height: 130px;
            ">
            <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              <div class="" style="
                  display: flex;
                  align-items: center;
                  color: #777;
                  
                ">
                <img src="../assets/images/f-0.png" alt="" style="width: 12px; height: 12px; margin-right: 4px"
                  v-if="item.game_type == 1" />
                <img src="https://sta.yyzb456.top/file/imgs/liveType/201912/png/69c3423db399c79e2937c9b36a072f0a" alt=""
                  style="width: 12px; height: 12px; margin-right: 4px" v-if="item.game_type == 2" />
                <img src="https://sta.yyzb456.top/file/common/20240412/51be7cde8b89133a0996be3a55802701.png" alt=""
                  style="width: 12px; height: 12px; margin-right: 4px" v-if="item.game_type == 3" />
                <div class=""
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;font-size: 14px;">
                  {{ item.league_name }}

                </div>
              </div>
              <div class="" style="color: #777;font-size: 14px;">
                {{ item.match_time }}
              </div>
            </div>
            <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
              ">
              <div class="">
                <div class="" style="display: flex; align-items: center">
                  <img :src="item.home_team_logo_text" alt="" style="width: 24px; height: 24px; margin-right: 4px" />
                  <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                    {{ item.home_team_name }}
                  </div>
                </div>
                <div class="" style="display: flex; align-items: center; margin-top: 10px">
                  <img :src="item.away_team_logo_text" alt="" style="width: 24px; height: 24px; margin-right: 4px" />
                  <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                    {{ item.away_team_name }}
                  </div>
                </div>
              </div>

              <div class="" v-if="item.live_status == 1">
                直播中...
              </div>
              <div class="" v-if="item.live_status == 0">
                <div class=""
                  style="color: #fff !important;background-color: #999;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                  v-if="item.is_reservation" @click="qxyuyue(item)">
                  已预约
                </div>
                <div class=""
                  style="color: #fff !important;background-color: #4b72f6;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                  v-else @click="goyuyue(item)">
                  预约
                </div>
              </div>
              <div class="" v-if="item.live_status == 2">
                已结束
              </div>
            </div>
          </div>
        </div> -->







        <div class="" style="width: 1200px;overflow: hidden;position: relative;height: 130px;">
          <div :style="{ left: left + 'px' }" class="gundongBox">
            <div class="" v-for="(item, index) in couseList" :key="index" style="
              border-right: 1px solid #eee;
              padding: 16px;
              box-sizing: border-box;
              flex-shrink: 0;
              width: 240px;
              height: 130px;
            ">
              <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
                <div class="" style="
                  display: flex;
                  align-items: center;
                  color: #777;
                  
                ">
                  <img src="../assets/images/f-0.png" alt="" style="width: 12px; height: 12px; margin-right: 4px"
                    v-if="item.game_type == 1" />
                  <img src="https://sta.yyzb456.top/file/imgs/liveType/201912/png/69c3423db399c79e2937c9b36a072f0a"
                    alt="" style="width: 12px; height: 12px; margin-right: 4px" v-if="item.game_type == 2" />
                  <img src="https://sta.yyzb456.top/file/common/20240412/51be7cde8b89133a0996be3a55802701.png" alt=""
                    style="width: 12px; height: 12px; margin-right: 4px" v-if="item.game_type == 3" />
                  <div class=""
                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;font-size: 14px;">
                    {{ item.league_name }}

                  </div>
                </div>
                <div class="" style="color: #777;font-size: 14px;">
                  {{ item.match_time }}
                </div>
              </div>
              <div class="" style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;
              ">
                <div class="">
                  <div class="" style="display: flex; align-items: center">
                    <img :src="item.home_team_logo_text" alt="" style="width: 24px; height: 24px; margin-right: 4px" />
                    <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                      {{ item.home_team_name }}
                    </div>
                  </div>
                  <div class="" style="display: flex; align-items: center; margin-top: 10px">
                    <img :src="item.away_team_logo_text" alt="" style="width: 24px; height: 24px; margin-right: 4px" />
                    <div class="" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 100px;">
                      {{ item.away_team_name }}
                    </div>
                  </div>
                </div>

                <div class="" v-if="item.live_status == 1">
                  直播中...
                </div>
                <div class="" v-if="item.live_status == 0">
                  <div class=""
                    style="color: #fff !important;background-color: #999;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                    v-if="item.is_reservation" @click="qxyuyue(item)">
                    已预约
                  </div>
                  <div class=""
                    style="color: #fff !important;background-color: #4b72f6;width: 52px;height: 25px;font-size: 12px;border-radius: 4px;text-align: center;line-height: 25px;"
                    v-else @click="goyuyue(item)">
                    预约
                  </div>
                </div>
                <div class="" v-if="item.live_status == 2">
                  已结束
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="" style="position: absolute; right: -60px; top: 50px" @click="rightSlide1">
          <i class="el-icon-arrow-right" style="margin: 0 10px; font-size: 40px"></i>
        </div>
      </div>
      <!-- 正在热播 -->
      <div class="" style="margin-top: 30px" v-if="list1.length > 0">
        <div class="" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          ">
          <img src="../assets/images/zhengzairebo.png" alt="" style="height: 50px; width: 180px" />
          <div class="" style="display: flex; align-items: center" @click="goALL">
            查看更多
            <img src="../assets/imgs/arrow-right.png" alt="" style="height: 20px; width: 20px" />
          </div>
        </div>
        <myList :list="list1"></myList>
      </div>
      <!-- 热门主播 -->
      <div style="
          background-color: #fff;
          border-radius: 4px;
          margin-top: 60px;
          position: relative;
          padding-top: 20px;
        ">
        <img src="../assets/images/remenzhubopng.png" alt="" style="
            width: 100%;
            height: 58px;
            display: block;
            position: absolute;
            top: -30px;
          " />
        <div class="" style="height: 196px; display: flex; align-items: center">
          <div class="" @click="leftSlide">
            <i class="el-icon-arrow-left" style="margin: 0 10px; font-size: 40px"></i>
          </div>
          <div style="
              background-color: #fff;
              border-right: none;
              border-radius: 4px;
              overflow-x: scroll;
              display: flex;
              flex: 1;
            " class="scroll_wrapper1" ref="wrapperCon">
            <div class="" v-for="(item, index) in newArr" :key="index" style="
                text-align: center;
                padding: 0 26px;
                flex-shrink: 0;
                display: block;
                margin: 0 26px;
              " @click="goDetail(item)">
              <img :src="baseUrl + item.user.avatar" alt="" style="
                  width: 80px;
                  border-radius: 50%;
                  height: 80px;
                  display: block;
                  margin-bottom: 3px;
                  display: block;
                " />
              {{ item.user.nickname }}
            </div>
          </div>
          <div class="" @click="rightSlide">
            <i class="el-icon-arrow-right" style="margin: 0 10px; font-size: 40px"></i>
          </div>
        </div>
      </div>
      <!-- 足球直播 -->
      <div class="" style="margin-top: 60px" v-if="list2.length > 0">
        <div class="" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          ">
          <img src="../assets/images/zuqiuzhibo.png" alt="" style="height: 32px; width: 132px" />
          <div class="" style="display: flex; align-items: center" @click="goALL">
            查看更多
            <img src="../assets/imgs/arrow-right.png" alt="" style="height: 20px; width: 20px" />
          </div>
        </div>
        <myList1 :list="list2"></myList1>
      </div>
      <!-- 篮球直播 -->
      <div class="" style="margin-top: 30px" v-if="list3.length > 0">
        <div class="" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          ">
          <img src="../assets/images/lanqiuzhibo.png" alt="" style="height: 32px; width: 132px" />
          <div class="" style="display: flex; align-items: center" @click="goALL">
            查看更多
            <img src="../assets/imgs/arrow-right.png" alt="" style="height: 20px; width: 20px" />
          </div>
        </div>
        <myList1 :list="list3"> </myList1>
      </div>
      <!-- 底部其他 -->
      <div class="" style="margin-top: 30px" v-if="list4.length > 0">
        <div class="" style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          ">
          <img src="../assets/images/qita.png" alt="" style="height: 32px; width: 96px" />
          <div class="" style="display: flex; align-items: center" @click="goALL">
            查看更多
            <img src="../assets/imgs/arrow-right.png" alt="" style="height: 20px; width: 20px" />
          </div>
        </div>
        <myList1 :list="list4"></myList1>
      </div>
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTop.vue";
import NavTop1 from "../components/NavTopWhit.vue";
import myList from "../components/MyList.vue";
import myList1 from "../components/MyList1.vue";
import liveTv from "../views/live-tv.vue";
import {
  // getRoomInfo
  getLivelist,
  getsaichenglist,
  getConfreservationig,
  getConfig,
  hostUser,
  hotLive
} from "../api/user.js";
export default {
  components: {
    NavTop,
    myList,
    myList1,
    NavTop1,
    liveTv,
  },
  data() {
    return {
      carousel: [], //轮播
      list1: [], //全部
      list2: [], //足球
      list3: [], //篮球
      page: 1,
      total: 0,
      current1: "",
      isTop: true,
      current2: 0,
      detail: {
        away_logo: "",
        away_name: "",
        clarity: {},
        clicktime: 1747287486,
        deletetime: 0,
        home_logo: "",
        home_name: "",
        hotvotes: 0,
        id: 200,
        is_home: 0,
        is_live: 1,
        ishot: 0,
        islive: 1,
        isliveName: "Live",
        isrecommend: 0,
        live_duration: "",
        match_id: 0,
        match_time: "",
        pull: "",
        push: "",
        starttime: 0,
        stream: "",
        thumb: "",
        title: "【BAT】CHEUN / CHOI vs KUSUM / PRATI",
        type: 2,
        typeName: "Lain",
        uid: 174,
        viewers: 1011,
      },
      reserve: {},
      userData: "",
      basketball: "",
      heat: "",
      couseList: [],
      topList: [],
      loading: false,
      newArr: [],
      list4: [],
      bgImg: '',
      aotoPl: false,
      left: 0,
      huadongLength: 0,
      huadongCurrent: 0
    };
  },
  created() {
    this.getList();
    this.getList1();
    this.getList2();
    this.getList3();
    this.getscList();
    this.getBack();
    this.gethotUser();
    this.gettopList();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    gettopList() {
      hotLive().then((res) => {
        if (res.data.length > 0) {
          if (res.data.length > 5) {
            this.topList = res.data.slice(0, 5);
            this.detail = this.topList[0];
          } else {
            this.topList = res.data
            this.detail = this.topList[0];
          }
        }

      });
    },
    gethotUser() {
      hostUser().then((res) => {
        this.newArr = res.data

      });
    },
    getBack() {
      getConfig().then((res) => {
        this.bgImg = res.data.pc_home_bg;

      });

    },
    goyuyue(item) {
      getConfreservationig({
        id: item.id,
        type: 1
      }).then((res) => {
        if (res.code == 1) {
          item.is_reservation = true
        }
      });
    },
    qxyuyue(item) {
      getConfreservationig({
        id: item.id,
        type: 0
      }).then((res) => {
        if (res.code == 1) {
          item.is_reservation = false
        }
      });
    },
    changTop(index) {
      this.current2 = index;
      this.detail = this.topList[index];
      this.aotoPl = true
    },
    getscList() {
      let today = new Date();
      let obj = {};
      obj = {
        time: today.toISOString().slice(0, 10),
      };
      getsaichenglist().then((res) => {
        console.log(res);
        this.couseList = res.data;
        this.huadongLength = res.data.length

      });
    },
    getList() {
      this.loading = true;
      getLivelist().then((res) => {
        console.log("全部直播列表", res.data.data);
        this.loading = false;
        this.list1 = res.data.data;
        //利用findindex的特性，查找当前元素第一次出现的索引，如果与当前循环的索引一致，则表示无重复项

        // this.newArr = this.list1.filter(
        //   (item, index, self) =>
        //     self.findIndex((v) => v.user_id === item.user_id) === index
        // );

        // if (this.list1.length > 0) {
        //   if (this.list1.length > 5) {
        //     this.topList = this.list1.slice(0, 5);
        //     this.detail = this.topList[0];
        //   } else {
        //     this.topList = this.list1;
        //     this.detail = this.topList[0];
        //   }
        // }
      });
    },
    // 足球
    getList1() {
      getLivelist({ game_type: 1 }).then((res) => {
        console.log("足球", res);
        this.list2 = res.data.data;
      });
    },
    // 篮球
    getList2() {
      getLivelist({ game_type: 2 }).then((res) => {
        console.log("篮球", res);
        this.list3 = res.data.data;
      });
    },
    // 篮球
    getList3() {
      getLivelist({ game_type: 3 }).then((res) => {
        console.log("其他", res);
        this.list4 = res.data.data;
      });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop == 0) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    goType() {
      this.$router.push("/text");
    },
    goDetail(item) {
      if (item.types == 3) {
        // 原始流
        this.$router.push({
          path: "/detailNew",
          query: {
            id: item.id,
          },
        });
      } else {
        // 原始流
        this.$router.push({
          path: "/details",
          query: {
            id: item.id,
          },
        });
      }
    },
    goALL() {
      this.$router.push("/text");
    },
    getDateTimeFormat(unixtime) {
      var currTime = Date.parse(new Date());
      var winTime = new Date(unixtime.replace(/-/g, "/")).getTime();
      var time = parseInt(currTime) / 1000 - parseInt(winTime) / 1000;
      time = Math.abs(time);
      // // 少于一分钟
      if (time < 60) {
        return Math.floor(minuies) + "秒前";
      }
      // 秒转分钟
      var minuies = time / 60;
      if (minuies < 60) {
        return Math.floor(minuies) + "分钟前";
      }
      // 秒转小时
      var hours = time / 3600;
      if (hours < 24) {
        return Math.floor(hours) + "小时前";
      }
      //秒转天数
      var days = time / 3600 / 24;
      if (days < 30) {
        return Math.floor(days) + "天前";
      }
      //秒转月
      var months = time / 3600 / 24 / 30;
      if (months < 12) {
        return Math.floor(months) + "月前";
      }
      //秒转年
      var years = time / 3600 / 24 / 30 / 12;
      return Math.floor(years) + "年前";
    },
    // 获取当前日期时间
    timestampToTime() {
      var date = new Date();
      // var Y = date.getFullYear() + '/';
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
      // var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ':';
      // var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() + ':';
      // var ss = date.getSeconds() < 10 ? '0' + date.getDate() : date.getSeconds();
      // return Y + M + D + hh + mm + ss;
      return M + D;
    },

    currenfChange(e) {
      console.log(e);
      this.page = e;
      this.getlist();
    },
    // 左箭头
    leftSlide() {
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon.scrollLeft;
      console.log(this.$refs.wrapperCon, "left");
      let num = 0;
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        if (!left || num >= 260) {
          // 停止滚动
          clearInterval(this.timer);
          this.timer = null;
          return;
        }
        this.$refs.wrapperCon.scrollLeft -= 13;
        num += 30;
      }, 20);
    },
    // 右箭头
    rightSlide() {
      console.log(4984);
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon.scrollLeft;
      console.log(this.$refs.wrapperCon, "left");
      // 保存元素的整体宽度
      let scrollWidth = this.$refs.wrapperCon.scrollWidth;
      // 保存元素的可见宽度
      let clientWidth = this.$refs.wrapperCon.clientWidth;
      let num = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (left + clientWidth >= scrollWidth || num >= 260) {
          clearInterval(this.timer);
          return;
        }
        this.$refs.wrapperCon.scrollLeft += 13;
        num += 30;
      }, 20);
    },

    // 左箭头
    leftSlide1() {
      // 保存滚动盒子左侧已滚动的距离
      // let left = this.$refs.wrapperCon1.scrollLeft;
      // console.log(this.$refs.wrapperCon1, "left");
      // let num = 0;
      // clearInterval(this.timer);
      // this.timer = null;
      // this.timer = setInterval(() => {
      //   if (!left || num >= 240) {
      //     // 停止滚动
      //     clearInterval(this.timer);
      //     this.timer = null;
      //     return;
      //   }
      //   this.$refs.wrapperCon1.scrollLeft -= 12;
      //   num += 12;
      // }, 20);
      if (this.huadongCurrent == 0) {
        console.log('是第一个');

      } else {
        this.left += 240
        this.huadongCurrent -= 1
      }

    },
    // 右箭头
    rightSlide1() {

      if (this.huadongLength - this.huadongCurrent > 5) {
        this.left -= 240
        this.huadongCurrent += 1
      } else {

        return
      }
      // console.log(4984);
      // // 保存滚动盒子左侧已滚动的距离
      // let left = this.$refs.wrapperCon1.scrollLeft;
      // console.log(this.$refs.wrapperCon1, "left");
      // // 保存元素的整体宽度
      // let scrollWidth = this.$refs.wrapperCon1.scrollWidth;
      // // 保存元素的可见宽度
      // let clientWidth = this.$refs.wrapperCon1.clientWidth;
      // let num = 0;
      // clearInterval(this.timer);
      // this.timer = setInterval(() => {
      //   if (left + clientWidth >= scrollWidth || num >= 240) {
      //     clearInterval(this.timer);
      //     return;
      //   }
      //   this.$refs.wrapperCon1.scrollLeft += 12;
      //   num += 12;
      // }, 20);
    },
  },
};
</script>
<style scoped>
.home {
  background-color: #f0f1f6;
}

.block {
  width: 100%;
  height: 640px;
  z-index: 3;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.main-box {
  width: 1200px;
  margin: 20px auto;
  background-color: #f0f1f6;
}

.goodsBox div:nth-child(4n) {
  margin-right: 0 !important;
}

.videoBox:hover .btuBox {
  background-color: #4b72f6 !important;
  color: #fff !important;
  cursor: pointer;
}

/*隐藏滚动条*/
.scroll_wrapper1::-webkit-scrollbar {
  display: none;
}

.active2 {
  border: 2px solid #4b72f6;
}

.gundongBox {


  background-color: #fff;
  border: 1px solid #eee;
  border-right: none;
  border-radius: 4px;
  display: flex;
  height: 130px;
  position: absolute;



}

</style>
